/* SILVERCASE theme — working cart, variant picker, UI */
(function () {
  "use strict";
  var CFG = window.SILVERCASE || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money formatting (Shopify standard) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var fmt = format || CFG.moneyFormat || "${{amount}}";
    function num(n, p, t, d) {
      p = isNaN(p = Math.abs(p)) ? 2 : p; t = t === undefined ? "," : t; d = d === undefined ? "." : d;
      var s = n < 0 ? "-" : "", i = parseInt(n = Math.abs(+n || 0).toFixed(p), 10) + "",
          j = (j = i.length) > 3 ? j % 3 : 0;
      return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
             (p ? d + Math.abs(n - i).toFixed(p).slice(2) : "");
    }
    var value = "", placeholder = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = placeholder ? placeholder[1] : "amount";
    switch (token) {
      case "amount": value = num(cents / 100.0, 2); break;
      case "amount_no_decimals": value = num(cents / 100.0, 0); break;
      case "amount_with_comma_separator": value = num(cents / 100.0, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = num(cents / 100.0, 0, ".", ","); break;
      default: value = num(cents / 100.0, 2);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }
  window.SCmoney = function (c) { return formatMoney(c); };

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $("#toast"); if (!t) return;
    $("#toastMsg").textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }

  /* ---------- cart config (from theme settings, see theme.liquid) ---------- */
  var C = CFG.cart || {};
  var PROTECT_ID = (C.protect && C.protect.id) || 0;
  var GIFT_ID = (C.gift && C.gift.id) || 0;
  var cartBusy = false;

  function isAddonId(vid) { return (PROTECT_ID && vid === PROTECT_ID) || (GIFT_ID && vid === GIFT_ID); }

  /* ---------- cart drawer open/close ---------- */
  function openCart() {
    var d = $("#drawer"), o = $("#overlay");
    if (!d) return;
    d.classList.add("open"); if (o) o.classList.add("open");
    d.setAttribute("aria-hidden", "false");
  }
  function closeCart() {
    var d = $("#drawer"), o = $("#overlay");
    if (!d) return;
    d.classList.remove("open"); if (o) o.classList.remove("open");
    d.setAttribute("aria-hidden", "true");
  }

  /* ---------- low-level cart ops ---------- */
  function fetchCartRaw() {
    return fetch(CFG.routes.cart_js, { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); });
  }
  function cartChangeRaw(key, qty) {
    return fetch(CFG.routes.cart_change, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }
  function cartAddRaw(id, qty) {
    return fetch(CFG.routes.cart_add, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function () { return fetchCartRaw(); });
  }

  /* Single entry point: render the cart, then update offers + auto-reconcile add-ons. */
  function applyCart(cart) { renderCart(cart); afterCartRender(cart); }
  function fetchCart() { return fetchCartRaw().then(function (cart) { applyCart(cart); return cart; }); }
  function changeLine(key, qty) { return cartChangeRaw(key, qty).then(applyCart); }

  /* ---------- render line items (add-on aware) ---------- */
  function renderCart(cart) {
    var count = cart.item_count;
    $$("#cartCount").forEach(function (el) { el.textContent = count; });
    var body = $("#cartBody"), sub = $("#subtotal");
    if (!body) return;

    // Wallets = everything that isn't the protection or gift add-on.
    var walletItems = (cart.items || []).filter(function (it) { return !isAddonId(it.variant_id); });

    if (!walletItems.length) {
      body.innerHTML = '<div class="empty"><div class="big">&#9645;</div>Your cart is empty.<br>Pick a print to get started.</div>';
      if (sub) sub.textContent = formatMoney(cart.total_price || 0);
      return;
    }

    body.innerHTML = "";
    cart.items.forEach(function (item) {
      // Protection is represented by the toggle in the footer, never as a normal line.
      if (PROTECT_ID && item.variant_id === PROTECT_ID) return;

      var isGift = GIFT_ID && item.variant_id === GIFT_ID;
      var img = item.image ? item.image : (CFG.fallbackImages && CFG.fallbackImages[0]);
      var variant = (item.variant_title && item.variant_title.indexOf("Default") === -1) ? item.variant_title : (item.product_type || "");
      var row = document.createElement("div");

      if (isGift) {
        var giftPrice = item.final_line_price === 0 ? "FREE" : formatMoney(item.final_line_price);
        row.className = "line line--gift";
        row.innerHTML =
          '<div class="line-img"><img src="' + img + '" alt=""></div>' +
          '<div class="line-info"><h4>' + item.product_title + ' <span class="gift-pill">GIFT</span></h4>' +
          '<div class="sub">' + (variant || "Unlocked with your order") + '</div></div>' +
          '<div class="line-price">' + giftPrice + '</div>';
        body.appendChild(row);
        return;
      }

      row.className = "line";
      row.innerHTML =
        '<div class="line-img"><img src="' + img + '" alt=""></div>' +
        '<div class="line-info"><h4>' + item.product_title + '</h4>' +
        '<div class="sub">' + variant + '</div>' +
        '<div class="lc">' +
          '<button aria-label="Decrease" data-a="dec" data-key="' + item.key + '">&minus;</button>' +
          '<b>' + item.quantity + '</b>' +
          '<button aria-label="Increase" data-a="inc" data-key="' + item.key + '">+</button>' +
          '<button aria-label="Remove" data-a="rm" data-key="' + item.key + '" style="margin-left:6px">&#128465;</button>' +
        '</div></div>' +
        '<div class="line-price">' + formatMoney(item.final_line_price) + '</div>';
      body.appendChild(row);
    });
    body.querySelectorAll("button").forEach(function (b) {
      b.addEventListener("click", function () {
        var key = b.dataset.key, a = b.dataset.a;
        var item = cart.items.filter(function (x) { return x.key === key; })[0];
        if (!item) return;
        var q = item.quantity;
        if (a === "inc") q = q + 1;
        if (a === "dec") q = Math.max(0, q - 1);
        if (a === "rm") q = 0;
        changeLine(key, q);
      });
    });
    if (sub) sub.textContent = formatMoney(cart.total_price);
  }

  /* ---------- offers: progress bar, gift, protection ---------- */
  function walletStats(cart) {
    var qty = 0, subtotal = 0;
    (cart.items || []).forEach(function (it) {
      if (isAddonId(it.variant_id)) return;
      qty += it.quantity;
      subtotal += it.final_line_price;
    });
    return { qty: qty, subtotal: subtotal };
  }
  function lineFor(cart, vid) {
    var m = (cart.items || []).filter(function (it) { return it.variant_id === vid; });
    return m.length ? m[0] : null;
  }

  function updateRewards(cart) {
    var box = $("#cartRewards"); if (!box) return;
    var fs = C.freeship || {}, dc = C.discount || {};
    var st = walletStats(cart);
    if ((!fs.enabled && !dc.enabled) || st.qty === 0) { box.hidden = true; return; }
    box.hidden = false;

    // Build the list of goals in ascending order.
    var goals = [];
    if (fs.enabled) goals.push({ at: fs.threshold, prog: fs.msgProgress, done: fs.msgDone });
    if (dc.enabled) goals.push({ at: dc.threshold, prog: dc.msgProgress, done: dc.msgDone });
    goals.sort(function (a, b) { return a.at - b.at; });

    var maxGoal = goals[goals.length - 1].at || 1;
    var pct = Math.max(0, Math.min(100, (st.subtotal / maxGoal) * 100));
    var fill = $("#cartRewardFill"); if (fill) fill.style.width = pct + "%";

    // Next unmet goal drives the headline message.
    var next = null;
    for (var i = 0; i < goals.length; i++) { if (st.subtotal < goals[i].at) { next = goals[i]; break; } }
    var msgEl = $("#cartRewardMsg");
    if (msgEl) {
      if (next) {
        var remaining = formatMoney(next.at - st.subtotal);
        msgEl.innerHTML = (next.prog || "{{ amount }} to go").replace(/\{\{\s*amount\s*\}\}/g, "<b>" + remaining + "</b>");
        box.classList.remove("all-done");
      } else {
        var last = goals[goals.length - 1];
        msgEl.innerHTML = "&#10003; " + (last.done || "Reward unlocked");
        box.classList.add("all-done");
      }
    }

    // Position + state of the milestone nodes.
    function setNode(el, goal) {
      if (!el) return;
      if (!goal) { el.hidden = true; return; }
      el.hidden = false;
      el.style.left = Math.min(100, (goal.at / maxGoal) * 100) + "%";
      el.classList.toggle("hit", st.subtotal >= goal.at);
      el.setAttribute("data-tip", st.subtotal >= goal.at ? goal.done : goal.prog.replace(/\{\{\s*amount\s*\}\}/g, formatMoney(Math.max(0, goal.at - st.subtotal))));
    }
    setNode($("#cartRewardNode1"), goals[0]);
    setNode($("#cartRewardNode2"), goals.length > 1 ? goals[1] : null);
  }

  function updateGiftUI(cart) {
    var box = $("#cartGift"); if (!box) return;
    var g = C.gift || {};
    var st = walletStats(cart);
    if (!g.enabled || st.qty === 0) { box.hidden = true; return; }
    var need = Math.max(0, (g.qty || 2) - st.qty);
    var unlocked = need === 0;
    // When unlocked the gift shows as its own line item, so the footer prompt is only
    // needed while it's still locked.
    if (unlocked) { box.hidden = true; return; }
    box.hidden = false;
    var t = $("#cartGiftTitle"); if (t) t.textContent = g.title || "Free Mystery Gift";
    var msgEl = $("#cartGiftMsg");
    if (msgEl) {
      var msg = (g.msgLocked || "Add {{ count }} more to unlock a free mystery gift").replace(/\{\{\s*count\s*\}\}/g, need);
      if (g.value) msg += " (valued at " + g.value + ")";
      msgEl.textContent = msg;
    }
    var stEl = $("#cartGiftState"); if (stEl) stEl.textContent = st.qty + "/" + (g.qty || 2);
  }

  function updateProtectUI(cart) {
    var box = $("#cartProtect"); if (!box) return;
    var p = C.protect || {};
    var st = walletStats(cart);
    if (!p.enabled || st.qty === 0) { box.hidden = true; return; }
    box.hidden = false;
    var t = $("#cartProtectTitle"); if (t) t.textContent = p.title || "Shipping Protection";
    var d = $("#cartProtectDesc"); if (d) d.textContent = p.desc || "";
    var pr = $("#cartProtectPrice"); if (pr) pr.textContent = p.price ? formatMoney(p.price) : "";
    var toggle = $("#cartProtectToggle");
    if (toggle) toggle.checked = !!lineFor(cart, PROTECT_ID);
  }

  /* Decide whether protection should be in the cart right now. */
  function wantsProtection(cart) {
    var p = C.protect || {};
    if (!p.enabled) return false;
    if (walletStats(cart).qty === 0) return false;
    var choice = sessionStorage.getItem("sc_protect_choice");
    if (choice === "off") return false;
    if (choice === "on") return true;
    return !!p.defaultOn; // no explicit choice yet -> follow the merchant default
  }

  /* One reconciling change per pass; re-runs until the cart matches the desired state. */
  function afterCartRender(cart) {
    updateRewards(cart);
    updateGiftUI(cart);
    updateProtectUI(cart);
    if (cartBusy) return;

    var st = walletStats(cart);

    // 1) Shipping protection
    if (C.protect && C.protect.enabled && PROTECT_ID) {
      var pLine = lineFor(cart, PROTECT_ID);
      var want = wantsProtection(cart);
      if (want && !pLine) { cartBusy = true; cartAddRaw(PROTECT_ID, 1).then(done).catch(fail); return; }
      if (!want && pLine) { cartBusy = true; cartChangeRaw(pLine.key, 0).then(done2).catch(fail); return; }
      if (pLine && pLine.quantity > 1) { cartBusy = true; cartChangeRaw(pLine.key, 1).then(done2).catch(fail); return; }
    }

    // 2) Mystery gift — driven purely by real wallet count.
    if (C.gift && C.gift.enabled && GIFT_ID) {
      var gLine = lineFor(cart, GIFT_ID);
      var desiredGift = st.qty >= (C.gift.qty || 2) ? 1 : 0;
      var currentGift = gLine ? gLine.quantity : 0;
      if (desiredGift !== currentGift) {
        cartBusy = true;
        if (desiredGift > 0 && !gLine) { cartAddRaw(GIFT_ID, 1).then(done).catch(fail); return; }
        cartChangeRaw(gLine.key, desiredGift).then(done2).catch(fail); return;
      }
    }

    function done(c) { cartBusy = false; applyCart(c); }
    function done2(c) { cartBusy = false; applyCart(c); }
    function fail() { cartBusy = false; }
  }

  /* ---------- add to cart ---------- */
  function addToCart(form) {
    var btn = $("#addBtn", form);
    var data = new FormData(form);
    if (btn) { btn.disabled = true; btn.classList.add("loading"); }
    fetch(CFG.routes.cart_add, {
      method: "POST",
      headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: data
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.classList.remove("loading"); }
        if (!res.ok) { toast(res.body && res.body.description ? res.body.description : "Could not add to cart"); return; }
        toast((res.body.product_title || "Item") + " added");
        fetchCart().then(openCart);
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.classList.remove("loading"); }
        form.submit(); // fall back to normal submit
      });
  }

  /* ---------- shipping-protection toggle ---------- */
  function initProtectToggle() {
    var toggle = $("#cartProtectToggle"); if (!toggle) return;
    toggle.addEventListener("change", function () {
      sessionStorage.setItem("sc_protect_choice", toggle.checked ? "on" : "off");
      fetchCart(); // afterCartRender will add or remove the line to match
    });
  }

  /* ---------- promo countdown (real deadline only) ---------- */
  function initCartTimer() {
    var box = $("#cartTimer"); if (!box) return;
    var endStr = box.getAttribute("data-end");
    var end = endStr ? new Date(endStr.replace(/\s+/, "T")).getTime() : NaN;
    var clock = $("#cartTimerClock");
    if (isNaN(end)) { box.hidden = true; return; }
    var expired = (C.timer && C.timer.expired) || "Offer ended";
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (clock) clock.textContent = expired;
        box.classList.add("expired");
        return;
      }
      box.hidden = false;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var pad = function (n) { return (n < 10 ? "0" : "") + n; };
      if (clock) clock.textContent = (h > 99 ? h : pad(h)) + ":" + pad(m) + ":" + pad(s);
      requestAnimationFrame(function () { setTimeout(tick, 1000); });
    }
    tick();
  }

  /* ---------- variant picker ---------- */
  function initBuyBlock() {
    var grid = $(".product-grid");
    if (!grid) return;
    var isDemo = grid.getAttribute("data-demo") === "true";
    var mainImg = $("#mainImg");
    var qtyEl = $("#qty");

    function selectVariant(el) {
      var img = el.getAttribute("data-image");
      var name = el.getAttribute("data-name");
      var price = el.getAttribute("data-price");
      var vid = el.getAttribute("data-variant");
      var available = el.getAttribute("data-available");

      if (mainImg && img) {
        mainImg.classList.add("swap");
        setTimeout(function () { mainImg.src = img; if (name) mainImg.alt = name; mainImg.classList.remove("swap"); }, 160);
      }
      $$(".thumb").forEach(function (t) { t.classList.toggle("active", t.getAttribute("data-variant") === vid && t.getAttribute("data-image") === img || (isDemo && t.getAttribute("data-image") === img)); });
      $$(".swatch").forEach(function (s) { s.classList.toggle("active", (vid && s.getAttribute("data-variant") === vid) || (isDemo && s.getAttribute("data-image") === img)); });
      var pn = $("#pickName"); if (pn && name) pn.textContent = name;
      var dn = $("#designName"); if (dn && name) dn.textContent = name;
      updateLowStock(el);

      if (!isDemo && vid) {
        var vinput = $("#variantId"); if (vinput) vinput.value = vid;
        var cp = $("#curPrice"); if (cp && price) cp.textContent = formatMoney(price);
        var bp = $("#btnPrice"); if (bp && price) bp.textContent = formatMoney(price * (parseInt(qtyEl && qtyEl.value, 10) || 1));
        var addBtn = $("#addBtn"), addLabel = $("#addLabel");
        if (addBtn) {
          var avail = available === "true";
          addBtn.disabled = !avail;
          if (addLabel) addLabel.textContent = avail ? "Add to cart" : "Sold out";
          if (bp) bp.style.display = avail ? "" : "none";
        }
      }
    }

    // Real low-stock badge — reads genuine Shopify inventory passed in via data-* attrs.
    var lowEl = $("#lowStock");
    function updateLowStock(el) {
      if (!lowEl) return;
      var thresh = parseInt(lowEl.getAttribute("data-threshold"), 10) || 0;
      var managed = el && el.getAttribute("data-invmanaged") === "true";
      var qtyRaw = el && el.getAttribute("data-inv");
      var qty = qtyRaw === null || qtyRaw === "" ? null : parseInt(qtyRaw, 10);
      if (!managed || qty === null || isNaN(qty) || qty <= 0 || qty > thresh) {
        lowEl.hidden = true;
        return;
      }
      lowEl.hidden = false;
      var n = lowEl.querySelector("[data-inv-count]");
      if (n) n.textContent = qty;
    }

    $$(".thumb, .swatch").forEach(function (el) {
      el.addEventListener("click", function () { selectVariant(el); });
    });
    // Seed the badge from the initially-selected swatch.
    updateLowStock($(".swatch.active") || $(".thumb.active"));

    function syncBtnPrice() {
      var bp = $("#btnPrice"); if (!bp) return;
      var active = $(".swatch.active") || $(".thumb.active");
      var price = active && active.getAttribute("data-price");
      var q = parseInt(qtyEl && qtyEl.value, 10) || 1;
      if (price) bp.textContent = formatMoney(price * q);
      else if (isDemo) bp.textContent = "$" + (26 * q).toFixed(2);
    }

    var plus = $("#plus"), minus = $("#minus");
    if (plus) plus.addEventListener("click", function () { qtyEl.value = Math.min(99, (parseInt(qtyEl.value, 10) || 1) + 1); syncBtnPrice(); });
    if (minus) minus.addEventListener("click", function () { qtyEl.value = Math.max(1, (parseInt(qtyEl.value, 10) || 1) - 1); syncBtnPrice(); });
    if (qtyEl) qtyEl.addEventListener("input", function () {
      var v = parseInt(qtyEl.value, 10) || 1; qtyEl.value = Math.max(1, Math.min(99, v)); syncBtnPrice();
    });

    var form = $("#buyForm");
    if (form) {
      form.addEventListener("submit", function (e) { e.preventDefault(); addToCart(form); });
    }
    var demoBtn = grid.querySelector('[data-demo="true"]#addBtn') || (isDemo ? $("#addBtn") : null);
    if (isDemo && demoBtn) {
      demoBtn.addEventListener("click", function () {
        toast("Add your product in Shopify admin to enable checkout");
      });
    }
  }

  /* ---------- cart page (+/- buttons) ---------- */
  function initCartPage() {
    var form = $("#cartForm"); if (!form) return;
    $$(".qbtn", form).forEach(function (b) {
      b.addEventListener("click", function () {
        var line = b.getAttribute("data-line");
        var input = form.querySelector('.qinput[data-line="' + line + '"]');
        if (!input) return;
        var v = parseInt(input.value, 10) || 0;
        input.value = b.getAttribute("data-a") === "inc" ? v + 1 : Math.max(0, v - 1);
        form.querySelector('[name="update"]').click();
      });
    });
  }

  /* ---------- header / drawer wiring ---------- */
  function initChrome() {
    var open = $("#cartOpen");
    if (open) open.addEventListener("click", function (e) { e.preventDefault(); fetchCart().then(openCart); });
    var close = $("#cartClose"); if (close) close.addEventListener("click", closeCart);
    var ov = $("#overlay"); if (ov) ov.addEventListener("click", closeCart);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

    var mt = $("#menuToggle"), mnav = $("#mobileNav");
    if (mt && mnav) {
      mt.addEventListener("click", function () {
        var openNow = mnav.classList.toggle("open");
        mt.setAttribute("aria-expanded", openNow);
      });
      $$("a", mnav).forEach(function (a) {
        a.addEventListener("click", function () { mnav.classList.remove("open"); mt.setAttribute("aria-expanded", "false"); });
      });
    }
  }

  /* ---------- ticker ---------- */
  function initTicker() {
    var track = $("#ticker"); if (!track) return;
    var items = ["Free shipping over $35", "Brushed stainless steel", "Holds 12 to 14 cards",
      "One press spring clip", "Sealed art print", "30 day returns", "Ten prints to pick from"];
    var html = items.map(function (t) { return "<span>" + t + "</span>"; }).join("");
    track.innerHTML = html + html;
  }

  /* ---------- init ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    initChrome();
    initBuyBlock();
    initCartPage();
    initTicker();
    initProtectToggle();
    initCartTimer();
    if ($("#cartBody")) { fetchCart(); }
  });
})();
